import { useEffect, useRef, useState } from 'react';
import { Table, Input, Button, Select, Form, InputNumber, Radio, Space, Tag, Row, Col } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import EventEmitter from '../utils/eventEmitter';
import { ActionColumn } from '../utils/tableMockData';



const EditableCell = ({ editing, dataIndex, title, form, inputType, options, record, index, children, ...restProps }) => {
  const onChange = (option, form, dataIndex) => EventEmitter.dispatch('entry_selected', {option, form, key:record.key, dataIndex});
  const onDeselected = (value, form, taxes, dataIndex) => EventEmitter.dispatch('entry_deselected', {value, taxes, form, dataIndex});
  

  const inputNode = inputType === 'select' ? 
    <Select 
      // onDeselect={(v)=> (dataIndex === 'taxes' || dataIndex === 'analytics') && onDeselected(v, form, options, dataIndex)} 
      mode={(dataIndex === 'taxes' || dataIndex==='analytics') && 'tags'} 
      options={options} 
      onChange={(value, option)=>onChange(option, form, dataIndex)} 
    /> :
    inputType === 'radio' ? 
    <Radio.Group className='flex flex-column'>
      <Space direction='vertical'>
        <Radio value={'debit'} className='font-normal'>Debit</Radio>
        <Radio value={'credit'} className='font-normal'>Credit</Radio>
      </Space>
    </Radio.Group> :
    inputType === 'number' ?
    <InputNumber />
    : <Input />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode}
        </Form.Item>
      ) : (
        <>{
            inputType === 'select' && dataIndex === 'taxes' ?
            form.getFieldValue('tax'+record.key) && 
            form.getFieldValue('tax'+record.key).map(tax => <Tag key={tax}>{tax}</Tag>) : 
            inputType === 'select' && dataIndex === 'analytics' ?
            form.getFieldValue('analytic'+record.key) && 
            form.getFieldValue('analytic'+record.key).map(analytic => <Tag key={analytic}>{analytic}</Tag>) : 
            inputType === 'select' && dataIndex === 'account_id' ? 
            form.getFieldValue(record.account_id) : 
            children 
          }</>
      )}
    </td>
  );
};


 
const EntryTable = ({dataSource, refund, setJournalEntries, columns, accounts, taxes, setTax, tax, analytics, status }) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;

  const edit = async (record) => {
    form.setFieldsValue({ ...record })
    setEditingKey(record.key)
  };

  const cancel = () => {
    setEditingKey('')
  }

  const save = async (record) => {
    try {
      const key = record.key;
      const row = await form.validateFields()
      const newData = [...dataSource]
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        console.log(newData)
        setJournalEntries(newData)
        setEditingKey('')
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }
  
  const addEntry = () => {
    let journalEntries_ = [...dataSource]
    let entryObj = {
      key: dataSource.length + 1,
      link: dataSource.length + 1,
      account_id: '',
      label: '',
      analytics: [],
      taxes: [],
      type: '',
      amount: 0
    }
    journalEntries_.push(entryObj)
    form.setFieldsValue({ ...entryObj })
    setJournalEntries(journalEntries_);
    setEditingKey(dataSource.length + 1)
  }



  const removeEntry = (record) => {
    let key = record.key;
    let entries = dataSource.filter((item) => item.key !== key)
    setJournalEntries(entries);

  }


  columns[columns.length - 1]['render'] = (_, record) =>
    ActionColumn(_, record, isEditing, save, edit, cancel, removeEntry)

  if (status === 'posted')
    delete columns[columns.length - 1]['render']



  useEffect(() => { 
    EventEmitter.subscribe('entry_selected', data => {
      const { option, form, key, dataIndex } = data;
      const { label, value } = option;
      if (dataIndex === 'taxes') {
        form.setFieldValue('tax'+key, option.map(tax => tax.label));
      }else if (dataIndex === 'analytics'){
        form.setFieldValue('analytic'+key, option.map(analytic => analytic.label));
      }else {
        form.setFieldValue(value, option.label);
      }
    });

  

    return () => {
      EventEmitter.unsubscribe('selected');
    }
  },[]);


  useEffect(() => {
    if (dataSource && accounts.length > 0) {
      dataSource.forEach((transaction) => {
        let account = accounts.find((account) => account._id === transaction.account_id);
        {account && form.setFieldValue(`${account._id}`, `${account.code} ${account.name}`);}
        if (transaction.analytics !== undefined) {
          let analytics_ = analytics.filter((analytic) => transaction.analytics.includes(analytic._id))
          form.setFieldValue('analytic'+transaction.key, analytics_.map(analytic => analytic.name));
        }
        if (transaction.taxes !== undefined) {
          let taxes_ = taxes.filter((tax) => transaction.taxes.includes(tax._id))
          form.setFieldValue('tax'+transaction.key, taxes_.map(tax => tax.name));
        }
      });
    }
  },[]);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
    ...col,
    onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      form: form,
      inputType: (col.dataIndex === 'account_id' || col.dataIndex === 'taxes' || col.dataIndex === 'analytics') ? 'select' : (col.dataIndex === 'type') ? 'radio' : (col.dataIndex === 'amount' || col.dataIndex === 'price' || col.dataIndex === 'quantity') ? 'number' : 'text',
      options: 
        col.dataIndex === 'account_id' && accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`})) ||
        col.dataIndex === 'taxes' && taxes.map(tax => ({value: tax._id, label: tax.name})) ||
        col.dataIndex === 'analytics' && analytics.map(analytic => ({value: analytic._id, label: analytic.name})),
      editing: isEditing(record),
    }),
  }});

  return (
    <Form 
        form={form} 
        component={false} 
        initialValues={{debit: 0, credit: 0,}}
        labelAlign='right'
        labelCol={{span: 15}}
      >
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={dataSource}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
        rowKey={'key'}

      />
      {status !== 'posted' && <Button onClick={addEntry}>Add Entry</Button>}
    </Form>
  );
};

export default EntryTable;
